module.exports = __webpack_public_path__ + "0bff2aec5eeb0e1a087b4ca97926bd56.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/floor_items/basketball.png
// module id = 3394
// module chunks = 0